module.exports = __webpack_public_path__ + "media/images/game_icon/en/VGDRINSECT-a7afc186dff39b53d28da03261b899d5.png";